module.exports = __webpack_public_path__ + "img/free_title.babb10f5.png";